export default function RepeatIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3182 13.0021C12.4897 12.2264 13.3517 11.0641 13.7541 9.71796C14.1565 8.3718 14.0737 6.92711 13.5202 5.63573C12.9666 4.34435 11.9775 3.28818 10.7251 2.65133C10 2.28285 8.4 2.00278 7.2 2.40144M11.3182 13.0021V10.6688M11.3182 13.0021H13.6669M4.66689 3.01279C3.49949 3.79139 2.64192 4.95454 2.24329 6.29995C1.84466 7.64536 1.9302 9.08794 2.48504 10.3768C3.03987 11.6657 4.0289 12.7193 5.28013 13.3545C6.53136 13.9897 7.6 14.0028 8.8 14.0028M4.66689 3.01279V5.33546M4.66689 3.01279H2.33356"
        stroke="#AFBD77"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
